function initHomeDefaultSliders() {
  const sliders = document.querySelectorAll('.js-home-default-slider');

  sliders.forEach((sliderEl, index) => {
    const className = `js-home-default-slider-${index + 1}`;

    if (!sliderEl.classList.contains(className)) {
      sliderEl.classList.add(className);
    }

    if (sliderEl.splideInstance) {
      sliderEl.splideInstance.destroy();
      sliderEl.classList.remove('splide-initialized');
    }

    const slidesCount = sliderEl.querySelectorAll('.splide__slide').length;

    const splide = new Splide(`.${className}`, {
      type: 'fade',
      rewind: true,
      speed: 300,
      perPage: 1,
      pagination: slidesCount > 1, 
      arrows: true,
    });

    splide.on('mounted', () => {
      const prevArrow = sliderEl.querySelector('.splide__arrow--prev');
      const nextArrow = sliderEl.querySelector('.splide__arrow--next');

      if (prevArrow) {
        prevArrow.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 60 24" width="60" height="24"
               fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <line x1="55" y1="12" x2="10" y2="12"/>
            <polyline points="15 6, 9 12, 15 18"/>
          </svg>`;
      }

      if (nextArrow) {
        nextArrow.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 60 24" width="60" height="24"
               fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <line x1="5" y1="12" x2="50" y2="12"/>
            <polyline points="45 6, 51 12, 45 18"/>
          </svg>`;
      }
    });

    let counterEl = sliderEl.querySelector('.splide__counter');
    if (!counterEl) {
      counterEl = document.createElement('div');
      counterEl.className = 'splide__counter';
      sliderEl.appendChild(counterEl);
    }

    const updateCounter = () => {
      counterEl.innerHTML = `<span class="current-slider">${splide.index + 1}</span><svg xmlns="http://www.w3.org/2000/svg" width="37.438" height="34.624" viewBox="0 0 37.438 34.624"><path id="Shape_2_copy" data-name="Shape 2 copy" class="cls-1" d="M109.534,903.679l0.678,0.734L73.466,938.322l-0.678-.735Z" transform="translate(-72.781 -903.688)"></path></svg><span>${slidesCount}</span>`;
    };

    splide.on('mounted move', updateCounter);

    splide.mount();
    updateCounter();

    sliderEl.classList.add('splide-initialized');
    sliderEl.splideInstance = splide;
  });

  setTimeout(() => {
    document.querySelectorAll('.js-slider-item-content').forEach(el => {
      el.classList.add('active');
    });
  }, 100);
}

document.addEventListener('DOMContentLoaded', initHomeDefaultSliders);

if (window.Shopify && Shopify.designMode) {
  ['shopify:section:load','shopify:section:select','shopify:block:select','shopify:block:deselect']
    .forEach(eventName => {
      document.addEventListener(eventName, () => {
        initHomeDefaultSliders();
      });
    });

  document.addEventListener('shopify:block:select', function(e){
    const sectionId = e.detail?.sectionId;
    const blockId   = e.detail?.blockId;

    const sectionEl = document.querySelector(`#shopify-section-${sectionId}`);
    if(!sectionEl) return;

    const sliderEl = sectionEl.querySelector('.js-home-default-slider');
    if(!sliderEl?.splideInstance) return;

    const slideEl = sliderEl.querySelector(`[data-block-id="${blockId}"]`).closest('.splide__slide');
    if(!slideEl) return;

    const slides = Array.from(sliderEl.querySelectorAll('.splide__slide'));
    const index  = slides.indexOf(slideEl);

    if(index >= 0){
      sliderEl.splideInstance.go(index);
    }
  });
}